import { ref, watch, isRef } from 'vue'
import ApiService from '@/services/apiService'

/**
 * Composable pour fetcher les endpoints du dashboard.
 * @param {string} url - URL de l'endpoint (ex: '/dashboard/kpi/sales')
 * @param {import('vue').Ref|import('vue').ComputedRef|Object} params - Params reactifs ou statiques
 * @returns {{ data: import('vue').Ref, loading: import('vue').Ref, error: import('vue').Ref, refresh: Function }}
 */
export function useDashboard(url, params = null) {
  const data = ref(null)
  const loading = ref(false)
  const error = ref(null)

  const fetchData = async () => {
    loading.value = true
    error.value = null

    try {
      const resolvedParams = params
        ? (isRef(params) ? params.value : params)
        : {}

      const response = await ApiService.get(url, resolvedParams)

      if (response.data && response.data.status === 'success') {
        data.value = response.data.data
      } else {
        data.value = response.data?.data || response.data
      }
    } catch (err) {
      console.error(`[useDashboard] Erreur ${url}:`, err)
      error.value = err.response?.data?.message || 'Une erreur est survenue'
    } finally {
      loading.value = false
    }
  }

  // Watch reactive params and refetch
  if (params && isRef(params)) {
    watch(params, () => {
      fetchData()
    }, { deep: true })
  }

  // Initial fetch
  fetchData()

  return { data, loading, error, refresh: fetchData }
}
